import React from 'react';

class Debrief extends React.Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {


        return (<div style={{textAlign: 'left', margin: "5px 40px"}}>
                <h1>Thank you for your feedback!</h1>
                <p>Thank you for contributing to the development of the multi-colour picker. All of your responses have been saved.</p>
                <h2>What's next?</h2>
                <p>Once we have enough responses, we will review the feedback and data we've obtained and identify areas for adjustment or improvement. We also have some of our own ideas about how to improve the picker that we are working on implementing in the future. You can learn more on <a href="http://polychromeproject.co.uk">the Polychrome Project website</a>.</p>
                <h2>Spread the word!</h2>
                <p>You've already made a massive contribution to the Project by trying out the multi-colour picker and telling us what you think. Please feel free to share the multi-colour picker and the Polychrome Project with other synaesthetes. We would love to get feedback from as many synaesthetes as possible!</p>
                <h2>Get in touch</h2>
                <p>If you think of something later that you forgot to mention on the feedback form, or you're struck by a brilliant idea, or you would just like to chat about synaesthesia and words, please contact us! We would love to hear from you about what you would like to see. You can find us at:</p>
                <p><strong>Website:</strong> <a href="http://polychromeproject.co.uk/contact-us">The Sussex Polychrome Project</a></p>
                <p><strong>Twitter:</strong> The Polychrome Project <a href="https://twitter.com/polychromeproj">@PolychromeProj</a></p>
                <p><strong>Stay in contact:</strong> If you would like to receive email updates when there is news about the Project, you can <a href="https://universityofsussex.eu.qualtrics.com/jfe/form/SV_3QJtzLBmYx1Tz0x">sign up to our mailing list here</a>.</p>
                <h2>Thanks again!</h2>
        </div>


    );
        }
    }

export default Debrief;